const locale = {
  PleaseSelect: 'Please select {label}',
  PleaseInput: 'Please enter {label}',
  StartTime: 'Start Time',
  EndTime: 'End Time',
  StartDate: 'Start Date',
  EndDate: 'End Date',
  SoFar: 'Present'
};

export default locale;
